import {
  ATTRIBUTE_FETCH,
  ATTRIBUTE_POST,
  ATTRIBUTE_UPDATE,
  CLEAR_FOCUSED_ATTRIBUTE,
  SET_FOCUSED_ATTRIBUTE_MODE,
} from '../action-types/focused-attribute-types';

export enum Modes {
  NEW = 'NEW',
  EDIT = 'EDIT',
  VIEW = 'VIEW',
}

type State = {
  mode?: Modes;
  data?: Record<string, any>;
}

const initialState = {
  mode: undefined,
  data: undefined,
};

const NEW_ATTRIBUTE = {
  name: '',
  attributeCategory: undefined,
  isGeneralAttribute: false,
  hasTrainingSystemAccess: false,
  isToggle: true,
  enumValues: [],
  translations: [],
  permissions: [],
}

export default function reducer(state: State = initialState, action) {
  switch (action.type) {
    case SET_FOCUSED_ATTRIBUTE_MODE:
      const mode = action.payload;
      return {
        ...state,
        mode,
        data: mode === Modes.NEW ? NEW_ATTRIBUTE : state.data,
      }
    case ATTRIBUTE_FETCH.REQUEST:
      return {
        ...state,
      }
    case ATTRIBUTE_FETCH.SUCCESS:
      return {
        ...state,
        data: action.payload.data,
      }
    case ATTRIBUTE_POST.SUCCESS:
    case ATTRIBUTE_UPDATE.SUCCESS:
    case CLEAR_FOCUSED_ATTRIBUTE:
      return initialState;
    default:
      return state;
  }
}